module.exports = __webpack_public_path__ + "resources/img/equipment_tab3_img2_m.dfa22a2de660797d74389b31220cc072.jpg";